module.exports = __webpack_public_path__ + "images/rb-logo-bid-manager.d9e0534.svg";